import { render, staticRenderFns } from "./ListDropdown.vue?vue&type=template&id=2ff00066&"
import script from "./ListDropdown.vue?vue&type=script&lang=js&"
export * from "./ListDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports